import { IsUUID, IsEnum, IsNumber, IsOptional, Min } from 'class-validator';
import {
  CreateFinancialsInterface,
  UpdateFinancialsInterface,
} from '../../interface/financials/modify-financials.interface';
import { FinancialsStatus } from '../../interface/financials/financials-response.interface';

export class CreateFinancialsDto implements CreateFinancialsInterface {

  @IsNumber()
  @Min(0, { message: 'Annual sales target must be at least 0' })
  annual_sales_target!: number;

  @IsEnum(FinancialsStatus)
  status!: FinancialsStatus;

  @IsOptional()
  @IsUUID()
  created_by_id!: string | null;

  @IsOptional()
  @IsUUID()
  updated_by_id!: string | null;
}

export class UpdateFinancialsDto implements UpdateFinancialsInterface {

  @IsUUID()
  id!: string;

  @IsOptional()
  @IsNumber()
  @Min(0)
  annual_sales_target?: number;

  @IsOptional()
  @IsEnum(FinancialsStatus)
  status?: FinancialsStatus;

  @IsUUID()
  updated_by_id!: string | null;
}